export const defaultDateFormat = 'DD/MM/YYYY';
export const hourMinuteFormat = 'HH:mm';
export const defaultCountdownFormat = 'mm:ss';
export const defaultTimeFormat = 'HH:MM';

const $ST = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/app`);

export const httpMethods = {
  GET: 'GET',
  POST: 'POST',
  OPTIONS: 'OPTIONS',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
};

export const responseTypes = {
  success: 'success',
  fail: 'fail',
};

export const buttonTypes = {
  default: 'default',
  primary: 'primary',
  danger: 'danger',
  dashed: 'dashed',
};

export const primaryColors = {
  red: '#f97173',
  green: '#7fb6a1',
  blue: '#89b0f4',
  yellow: '#ffb034',
  gray: '#aaaeb7',
  pink: '#ff90aa',
  purple: '#a17ac6',
  orange: '#ffa583',
};

export const secondaryColors = {
  light_red: '#fc9c9e',
  dark_red: '#c6484a',
  light_green: '#94d5bc',
  dark_green: '#508a73',
  light_blue: '#b0ccfc',
  dark_blue: '#6789c5',
  light_yellow: '#f9c97e',
  dark_yellow: '#d8880f',
  light_gray: '#cbd0db',
  dark_gray: '#7b7f8a',
};

export const packageStatusColors = [
  { enum_value: 33, value: primaryColors.gray },
  { enum_value: 34, value: secondaryColors.dark_blue },
  { enum_value: 37, value: primaryColors.yellow },
  { enum_value: 40, value: secondaryColors.light_green },
  { enum_value: 41, value: secondaryColors.dark_green },
  { enum_value: 46, value: secondaryColors.dark_red },
  { enum_value: 35, value: secondaryColors.dark_yellow },
];

export const packageStatusColorsByEnumValue = [
  { enum_value: '100', value: primaryColors.gray },
  { enum_value: '200', value: secondaryColors.dark_blue },
  { enum_value: '500', value: primaryColors.yellow },
  { enum_value: '610', value: secondaryColors.light_green },
  { enum_value: '700', value: secondaryColors.dark_green },
  { enum_value: '900', value: secondaryColors.dark_red },
  { enum_value: '300', value: secondaryColors.dark_yellow },
];

export const transferStatusColors = [
  { stateId: 57, value: primaryColors.gray },
  { stateId: 58, value: secondaryColors.light_green },
  { stateId: 60, value: secondaryColors.dark_green },
  { stateId: 59, value: secondaryColors.dark_red },
];

export const transferStatusColorsByEnumValue = [
  { enum_value: 57, value: primaryColors.gray },
  { enum_value: 58, value: secondaryColors.light_green },
  { enum_value: 60, value: secondaryColors.dark_green },
  { enum_value: 59, value: secondaryColors.dark_red },
];

export const clientCommands = [
  {
    command: 'PKG_STATE_TRANSITION',
    label: $ST.OMS.COMMANDS.APPROVE_PACKAGE,
    reloadData: true,
    selectionRequired: false,
    type: buttonTypes.primary,
  },
  {
    command: 'SPLIT_PACKAGE',
    label: $ST.OMS.COMMANDS.SPLIT_PACKAGE,
    reloadData: true,
    selectionRequired: true,
    type: buttonTypes.primary,
  },
  {
    command: 'RENEW_PACKAGE_PLAN',
    label: $ST.OMS.COMMANDS.RENEW_PACKAGE,
    reloadData: true,
    selectionRequired: false,
    type: buttonTypes.primary,
  },
  {
    command: 'COMPLETE_PACKAGING',
    label: $ST.OMS.COMMANDS.COMPLETE_PACKAGING,
    reloadData: true,
    selectionRequired: false,
    type: buttonTypes.primary,
  },
  {
    command: 'COMPLETE_PACKAGING_WITHOUT_SHIPMENT',
    label: $ST.OMS.COMMANDS.COMPLETE_PACKAGING_WITHOUT_SHIPMENT,
    reloadData: true,
    selectionRequired: false,
    type: buttonTypes.primary,
  },
  {
    command: 'SHIP_THE_PACKAGE_ADVANCED',
    label: $ST.OMS.COMMANDS.SHIP_THE_PACKAGE_ADVANCED,
    reloadData: true,
    selectionRequired: false,
    type: buttonTypes.primary,
  },
  {
    command: 'CHANNEL_BASED_COMPLETE_PACKAGING',
    label: $ST.OMS.COMMANDS.CHANNEL_BASED_COMPLETE_PACKAGING,
    reloadData: true,
    selectionRequired: false,
    type: buttonTypes.primary,
  },
  {
    command: 'SHIP_THE_PACKAGE',
    label: $ST.OMS.COMMANDS.SHIP_PACKAGE,
    reloadData: true,
    selectionRequired: false,
    type: buttonTypes.primary,
  },
  {
    command: 'READY_FOR_PICKUP',
    label: $ST.OMS.COMMANDS.READY_FOR_PICKUP,
    reloadData: true,
    selectionRequired: false,
    type: buttonTypes.primary,
  },
  {
    command: 'SHIP_THE_PACKAGE_ADVANCED',
    label: $ST.OMS.COMMANDS.SHIP_PACKAGE_ADVANCED,
    reloadData: true,
    selectionRequired: false,
    type: buttonTypes.primary,
  },
  {
    command: 'TRANSFER_STATE_TRANSITION',
    label: $ST.OMS.COMMANDS.CANCEL_TRANSFER,
    reloadData: true,
    selectionRequired: false,
    type: buttonTypes.primary,
  },
  {
    command: 'DETECTED_OUT_OF_STOCK_ITEM',
    label: $ST.OMS.COMMANDS.OUT_OF_STOCK_ITEM,
    reloadData: true,
    selectionRequired: true,
    type: buttonTypes.primary,
  },
  {
    command: 'READY_TO_SHIP_TRANSFER_ORDER',
    label: $ST.OMS.COMMANDS.READY_TO_SHIP_TRANSFER_ORDER,
    reloadData: true,
    selectionRequired: false,
    type: buttonTypes.primary,
  },
  {
    command: 'TRANSFER_ORDER_TRANSFERRED',
    label: $ST.OMS.COMMANDS.TRANSFER_ORDER_TRANSFERRED,
    reloadData: true,
    selectionRequired: false,
    type: buttonTypes.primary,
  },
  {
    command: 'IN_TRANSIT_TRANSFER_ORDER',
    label: $ST.OMS.COMMANDS.IN_TRANSIT_TRANSFER_ORDER,
    reloadData: true,
    selectionRequired: false,
    type: buttonTypes.primary,
  },
  {
    command: 'RENEW_TRANSFER_ORDER',
    label: $ST.OMS.COMMANDS.RENEW_TRANSFER_ORDER,
    reloadData: true,
    selectionRequired: false,
    type: buttonTypes.primary,
  },
  {
    command: 'TRANSFER_OUT_OF_STOCK',
    label: $ST.OMS.COMMANDS.TRANSFER_OUT_OF_STOCK,
    reloadData: true,
    selectionRequired: false,
    type: buttonTypes.primary,
  },
  {
    command: 'SELF_SERVICE_PACKAGE_DELIVERY_COMMAND',
    label: $ST.OMS.COMMANDS.SELF_SERVICE_PACKAGE_DELIVERY_COMMAND,
    reloadData: true,
    selectionRequired: false,
    type: buttonTypes.primary,
  },
  {
    command: 'UPDATE_PACKAGE_SHIPMENT_STATUS',
    label: $ST.OMS.COMMANDS.UPDATE_PACKAGE_SHIPMENT_STATUS,
    reloadData: true,
    selectionRequired: false,
    type: buttonTypes.primary,
  },
  {
    command: 'ASSIGN_PACKAGE_ITEMS_MANUALLY',
    label: $ST.OMS.COMMANDS.ASSIGN_PACKAGE_ITEMS_MANUALLY,
    reloadData: true,
    selectionRequired: true,
    type: buttonTypes.primary,
  },
];

export const CC_STATUS_MAP = {
  520: 'Müşteri Teslimatına Hazır',
  550: 'Teslim Edildi',
};



// WEBPACK FOOTER //
// ./src/appConstants/index.js